import type { CalendarAppointment } from '@cartwheel/api/v1'
import { formatTime } from './utils'

interface AppointmentPillProps {
  appointment: CalendarAppointment
  onClick: (appointment: CalendarAppointment) => void
}

export function AppointmentPill({ appointment, onClick }: AppointmentPillProps) {
  return (
    <button
      type="button"
      onClick={() => onClick(appointment)}
      className="w-full text-left rounded px-2 py-1 text-xs truncate leading-tight bg-forest-dark text-white hover:bg-forest cursor-pointer"
    >
      {formatTime(appointment.start_time)} {appointment.student_first_name}{' '}
      {appointment.student_last_name}
    </button>
  )
}
